import { CountdownState, CrowdHandlerWRState, CrowdHandlerEmailState } from '../types/crowdhandler';
import { copyToken } from '../components/tokenHandler';
export const wrEmailStateDefault: CrowdHandlerEmailState = {
    value: "",
    notification: "",
    submitted: false,
    valid: false,
    submitting: false,
    changing: false
};

export const chDefaultQueueState: CrowdHandlerWRState = {
    status: 1,
    token: {
        value: "",
        obfuscated: "",
        copied: false,
        copy: copyToken
    },
    obfuscatedToken: "",
    title: "",
    position: null,
    promoted: null,
    urlRedirect: "",
    onsale: "",
    message: "",
    slug: "",
    logo: "",
    stock: null,
    responseID: "",
    captchaRequired: false,
    rate: 0,
    sessionsExpire: 0,
    sessionsTimeout: 0,
    deployment: "",
    emailAvailable: 0,
    requested: "",
    hash: "",
    ttl: 0,
    isActive: false,
    isBlocked: false,
    isCountdown: false,
    isLoaded: false,
    isError: false,
    isRoomFull: false,
    isValid: true,
    displayCaptcha: false,
    displayStock: false,
    zeroStock: false,
    displayEmailMe: false,
    email: wrEmailStateDefault,
    priority: {
        available: 0,
        code: null,
        valid: false,
        submitting: false,
        submitted: false,
        applied: null,
        error: false,
        success: false,
    },
    // Optional promotion chime. `available` stays false unless a template
    // supplies `promotedSound`, so this is inert for every existing template.
    sound: {
        available: false,
        enabled: false,
        unlocked: false,
    },
    wait: null,
    estimate: null,
    announcement: "",
    progress: 10,
    nextPoll: 0,
    pollTTL: 60,
    checking: 0,
    shuffling: false,
    eta: null,
    etaAt: null,
    countdown: {
        seconds: 0,
        minutes: 0,
        hours: 0,
        totalseconds: 999999999,  // Large number so it never triggers "countdown complete"
        onsale: null,
        inHours: null,
        sHours: "--",
        sMinutes: "--",
        sSeconds: "--"
    },
    css: {
        title: ""
    }
};
